import React, { useState, useEffect } from "react";
import { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Typography,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { serverUrl } from "../../server";
import Cookies from "js-cookie";
import { RoleContext } from "../../RoleContext";
import Modal from "react-modal";
import { toast } from 'react-toastify';

const defaultTheme = createTheme();

const modalStyles = {
  content: {
    width: "400px",
    height: "200px",
    margin: "auto",
  },
};

const GetTracteurs = () => {
  Modal.setAppElement("#root");
  const userRole = useContext(RoleContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [loadingInProgress, setLoading] = useState(false);
  const token = Cookies.get("jwt");
  const [tracteurs, setTracteurs] = useState([]);
  const [selectedTracteur, setSelectedTracteur] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const navigate = useNavigate();

  const openModal = (tracteur) => {
    setSelectedTracteur(tracteur);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedTracteur(null);
    setModalOpen(false);
  };

  const deleteTracteur = (id) => {
    const token = Cookies.get("jwt");
    axios
      .delete(`${serverUrl}/api/tracteur/deletetracteur/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success("Tracteur supprimé avec succès");
          const token = Cookies.get("jwt");
          axios
            .get(`${serverUrl}/api/tracteur/gettracteurs`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((response) => {
              setTracteurs(response.data.tracteurs);
            })
            .catch((error) => {
              console.error(error);
            });
          setTimeout(() => {
            closeModal();
          }, 1000);
        } else {
          toast.error("Erreur lors de la suppression du tracteur");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Une erreur est survenue lors de la suppression du tracteur");
        setTimeout(() => {
          closeModal();
        }, 1000);
      });
  };

  useEffect(() => {
    const fetchTracteurs = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/tracteur/gettracteurs`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setTracteurs(response.data.tracteurs);
        setDataLoaded(true);
      } catch (error) {
        console.error(error);
      }
    };

    fetchTracteurs();
  }, [token]);

  return (
    <>
      {dataLoaded ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>N°</TableCell>
                <TableCell>Immatriculation</TableCell>
                <TableCell>Prestataire</TableCell>
                {userRole === "admin" && <TableCell>Actions</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {tracteurs.map((tracteur, index) => (
                <TableRow key={tracteur.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{tracteur.immat}</TableCell>
                  <TableCell>{tracteur.proprio_nom}</TableCell>
                  {userRole === "admin" && (
                    <TableCell>
                      <Button
                        onClick={() => {
                          navigate(`/dashboard/updatetracteur/${tracteur.id}`);
                        }}
                      >
                        <EditIcon />
                      </Button>
                      <Button onClick={() => openModal(tracteur)}>
                        <DeleteIcon />
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <p>Chargement...</p>
      )}
      <Modal isOpen={modalOpen} onRequestClose={closeModal} ariaHideApp={false} style={modalStyles}>
        {selectedTracteur && (
          <>
            <h2>Confirmation</h2>
            <p>Supprimer le tracteur?</p>
            <Button onClick={() => deleteTracteur(selectedTracteur.id)}>Confirmer</Button>
            <Button onClick={closeModal}>Annuler</Button>
          </>
        )}
      </Modal>
    </>
  );
};

export default GetTracteurs;
